import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-demande-service-speciality-chips",
  templateUrl: "./demande-service-speciality-chips.component.html",
  styleUrls: ["./demande-service-speciality-chips.component.scss"],
})
export class DemandeServiceSpecialityChipsComponent {
  @Input() specialities: any[] = [];
  @Input() selectedSpeciality: any = null;

  @Output() specialitySelected = new EventEmitter<any>();
}
